// export const API_ENDPOINT = 'http://172.172.172.90:10/api/v1'
//export const AUTH_API_ENDPOINT = 'http://localhost:5000/api/v1'
//export const USER_API_ENDPOINT = 'http://localhost:5050/api/v1'
export const AUTH_API_ENDPOINT = 'https://auth-api.bilimkahramanlari.org/api/v1'
export const USER_API_ENDPOINT = 'https://user-api.bilimkahramanlari.org/api/v1'
export const API_ENDPOINT = 'http://localhost:5050/api/v1'
// export const API_ENDPOINT = 'http://172.172.172.92:5051/api/v1'
// export const ASSETS_PATH = 'http://172.172.172.92:5051/resources/files/'
// export const ASSETS_PATH = 'http://localhost:5050/resources/files/'
export const ASSETS_PATH = 'https://user-api.bilimkahramanlari.org/resources/files/'
export const API_CLIENT_KEY = '877d0103-c19c-4b8d-a6d1-393e64b2e750'

export const END_DATE_THRESHOLD = 5;
export const WARNING_THRESHOLD = 10;
